import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { H3, Copy, Eyebrow } from "../Typography";
import ButtonLink from "../ButtonLink";
import { getImage, GatsbyImage } from "gatsby-plugin-image";

const CardWrapper = styled.div`
  padding: 20px;
`;

const TitleWithIndexNumber = styled(H3)`
  &:before {
    content: "${({ $number }) => $number} —";
    display: block;
    color: ${({ theme, $colour }) => theme.colours[$colour]};
    font-size: 30px;
    font-family: "supply-light", monospace;
    left: -15px;
    line-height: 0.85;
    margin-bottom: 20px;
  }
`;

const TitleLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme, $colour }) => theme.colours[$colour]};
`;

const LinkWrapper = styled.div`
  color: ${({ theme }) => theme.colours.grey};
  display: flex;
  align-items: center;
  margin-top: 30px;
`;

const PaddedCopy = styled(Copy)`
  padding-bottom: 20px;
`;

const ImageWrapper = styled.div`
  margin-bottom: 30px;
  img {
    max-width: 100%;
  }
`;

const List = styled.ul`
  display: flex;
  flex-direction: column;
`;

const ListItem = styled.li`
  list-style: none;
  display: block;
  border-top: 1px solid #cbcbcb;
  font-size: 20px;
  font-family: "Supply", monospace;
  font-weight: normal;
  font-style: normal;
  line-height: 16px;
  opacity: 0.5;
  padding: 9px 0 3px 0;
  margin-top: 16px;
  color: ${({ theme, $colour }) => theme.colours[$colour]};
`;

function HorizontalCard({
  eyebrow,
  title,
  titleColour,
  description,
  descriptionColour,
  ctaUrl,
  ctaLabel,
  backgroundColour,
  number,
  hideIndexNumberDisplay,
  image,
  bulletedList,
  cta,
}) {
  const { ctaLabel: ctaLabelCardProp, ctaUrl: ctaUrlCardProp } = cta || {};

  // cta prop will override the ctalabel and ctaurl of the card component
  const finalCtaLabel = ctaLabelCardProp || ctaLabel;
  const finalCtaUrl = ctaUrlCardProp || ctaUrl;

  return (
    <CardWrapper>
      {image && (
        <ImageWrapper>
          <GatsbyImage
            image={getImage(image)}
            alt={image?.description || "image"}
          />
        </ImageWrapper>
      )}
      {eyebrow && (
        <Eyebrow colour={titleColour || "grey"} marginBottom="30px">
          {eyebrow}
        </Eyebrow>
      )}
      {finalCtaUrl ? (
        <TitleLink $colour={titleColour} to={finalCtaUrl}>
          {hideIndexNumberDisplay ? (
            <H3 $colour={titleColour}>{title}</H3>
          ) : (
            <TitleWithIndexNumber
              $colour={titleColour}
              $number={number < 10 ? `0${number}` : number}
            >
              {title}
            </TitleWithIndexNumber>
          )}
        </TitleLink>
      ) : hideIndexNumberDisplay ? (
        <H3 $colour={titleColour}>{title}</H3>
      ) : (
        <TitleWithIndexNumber
          $colour={titleColour}
          $number={number < 10 ? `0${number}` : number}
        >
          {title}
        </TitleWithIndexNumber>
      )}
      {description && (
        <PaddedCopy colour={descriptionColour || titleColour}>
          {description}
        </PaddedCopy>
      )}
      {bulletedList && (
        <List>
          {bulletedList.map((item, i) => (
            <ListItem key={i} $colour={titleColour}>
              {item}
            </ListItem>
          ))}
        </List>
      )}
      {finalCtaUrl && (
        <LinkWrapper>
          <ButtonLink
            isWhite={
              !!(
                !backgroundColour ||
                backgroundColour === "default" ||
                backgroundColour === "white" ||
                backgroundColour === "alabasterWhite"
              )
            }
            label={finalCtaLabel}
            url={finalCtaUrl}
          />
        </LinkWrapper>
      )}
    </CardWrapper>
  );
}

export default HorizontalCard;
